import { api } from '@/api/client';
import {
  createSpouseRequestSchema,
  spouseNeedsCreation,
  spouseSchema,
  type CreateSpouseRequest,
  type Spouse,
} from '@mr-website/schemas';
import { isAxiosError } from 'axios';

export { spouseNeedsCreation };

export async function createSpouseOnCrm(input: CreateSpouseRequest): Promise<Spouse> {
  const payload = createSpouseRequestSchema.parse(input);

  try {
    const { data } = await api.post<Spouse>('/profile/spouse', payload);
    return spouseSchema.parse(data);
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message;
      if (typeof message === 'string' && message.trim()) {
        throw new Error(message);
      }
    }
    throw error;
  }
}

export function toCreateSpouseRequest(spouse: Spouse): CreateSpouseRequest {
  return createSpouseRequestSchema.parse({
    first_name: spouse.first_name,
    last_name: spouse.last_name,
    email_address: spouse.email_address,
    phone_mobile: spouse.phone_mobile,
    phone_mobile_country_code: spouse.phone_mobile_country_code,
  });
}
